const fs = {
  getFsAppConfig: () => {
    return {
      fsAppid: '',
      fsAppSecret: '',
    }
  },
}
export default fs
